export default __webpack_public_path__ + "locales/lo-LA/DownloadDialog.json?hash=06caa60aec458ca058ec727ae3152db7";